import { Brain, Target, Users, Mic, Camera, Map } from "lucide-react";

const SCHEDULE = [
  {
    time: "9AM",
    icon: Brain,
    title: "Introduction & Mindset",
    points: [
      "Entrepreneurship",
      "Discipline",
      "Execution",
      "Survival vs builder mindset",
    ],
  },
  {
    time: "10AM",
    icon: Target,
    title: "Business Strategy Workshop",
    points: [
      "Offers",
      "Pricing",
      "Positioning",
      "Audience",
      "Monetisation",
      "Business clarity",
    ],
  },
  {
    time: "1PM",
    icon: Users,
    title: "Networking & Environment",
    points: [
      "Networking",
      "Collaboration",
      "Conversations",
      "Accountability",
    ],
  },
  {
    time: "2PM",
    icon: Mic,
    title: "Content & Personal Brand",
    points: [
      "Content strategy",
      "Storytelling",
      "Social media",
      "Positioning",
    ],
  },
  {
    time: "3PM",
    icon: Camera,
    title: "Content Creation Session",
    points: [
      "Talking videos",
      "Reels",
      "Headshots",
      "Podcast clips",
      "Branding content",
    ],
  },
  {
    time: "5PM",
    icon: Map,
    title: "Action Planning",
    points: [
      "Personalised next steps",
      "Execution roadmap",
      "Accountability setup",
    ],
  },
];

export const Timeline = () => {
  return (
    <section
      id="schedule"
      data-testid="buildday-schedule-section"
      className="relative bg-[#0A0A0C] py-24 md:py-40 border-t border-zinc-800 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-16 md:mb-20">
          <div className="md:col-span-7">
            <div className="reveal flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-[#4F7CFF]" />
              <span className="text-xs tracking-[0.3em] uppercase text-[#4F7CFF] font-bold">
                What Happens During The Day
              </span>
            </div>
            <h2
              data-testid="buildday-schedule-headline"
              className="reveal text-4xl sm:text-5xl lg:text-6xl tracking-tighter font-extrabold text-white leading-[1.02]"
            >
              The schedule.{" "}
              <span className="italic font-light text-white">
                The work.
              </span>
            </h2>
          </div>
          <div className="md:col-span-5 flex md:items-end">
            <p className="reveal text-base md:text-lg leading-relaxed text-zinc-300 font-medium">
              Six focused blocks. Every minute is built to produce a tangible
              output — not more notes, not more theory. You leave with proof.
            </p>
          </div>
        </div>

        {/* Timeline */}
        <div className="relative">
          {/* vertical spine */}
          <div className="absolute left-[27px] md:left-1/2 top-0 bottom-0 w-px bg-zinc-700 hidden sm:block" aria-hidden="true" />

          <div className="space-y-6 md:space-y-0">
            {SCHEDULE.map((block, i) => {
              const Icon = block.icon;
              const isEven = i % 2 === 0;
              return (
                <div
                  key={block.time}
                  data-testid={`buildday-timeline-${i + 1}`}
                  className="reveal relative md:grid md:grid-cols-2 md:gap-12 md:items-stretch"
                >
                  {/* Spine dot */}
                  <div className="hidden sm:flex absolute left-[19px] md:left-1/2 top-8 w-4 h-4 -ml-2 items-center justify-center z-10">
                    <span className="block w-3 h-3 bg-[#4F7CFF] rotate-45" />
                  </div>

                  {/* Card — mobile always left, desktop alternating */}
                  <div className={`${isEven ? "md:pr-12 md:text-right" : "md:order-2 md:pl-12"} pl-14 md:pl-0`}>
                    <div className={`group bg-[#15161B] hover:bg-[#1A1B22] border border-zinc-800 hover:border-zinc-700 p-6 md:p-10 transition-all duration-500 ${isEven ? "md:mr-0" : ""}`}>
                      <div className={`flex items-center gap-4 mb-6 ${isEven ? "md:justify-end" : ""}`}>
                        <div className={`flex items-center gap-3 ${isEven ? "md:flex-row-reverse" : ""}`}>
                          <span className="inline-flex items-center justify-center w-12 h-12 border border-[#4F7CFF]/30 bg-[#4F7CFF]/5">
                            <Icon className="w-5 h-5 text-[#4F7CFF]" strokeWidth={1.4} />
                          </span>
                          <span className="text-2xl md:text-3xl font-extrabold tracking-tighter text-white">
                            {block.time}
                          </span>
                        </div>
                      </div>
                      <h3 className="text-xl md:text-2xl tracking-tight font-bold text-white mb-5 leading-tight">
                        {block.title}
                      </h3>
                      <ul className={`space-y-1.5 ${isEven ? "md:ml-auto" : ""}`}>
                        {block.points.map((p) => (
                          <li
                            key={p}
                            className={`flex items-center gap-3 text-sm text-zinc-200 ${isEven ? "md:flex-row-reverse md:justify-start" : ""}`}
                          >
                            <span className="w-1 h-1 bg-zinc-500 flex-shrink-0" />
                            <span>{p}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>

                  {/* Empty spacer for alternating layout (desktop only) */}
                  <div className="hidden md:block" aria-hidden="true" />

                  {/* Mobile-only side dot */}
                  <div className="sm:hidden absolute left-2 top-6 w-3 h-3 bg-[#4F7CFF] rotate-45" />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
